export default {"src":"/_next/static/media/cut.bc4779e5.svg","height":28,"width":28,"blurWidth":0,"blurHeight":0};